import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator, type Firestore } from "firebase/firestore";
import { getAuth, connectAuthEmulator, type Auth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator, type Functions } from "firebase/functions";

/**
 * Firebase public config.
 * These values are not secrets — they're safe to expose client-side.
 * The actual values are injected at build-time via VITE_FIREBASE_* env vars
 * (set in each app's .env or CI environment).
 *
 * Actual project config is wired in Phase 3. During Phase 1/2 we use the emulator.
 */
const firebaseConfig = {
  apiKey: "AIzaSyDdV49izT6MbQmyeq18rRj9AVDC9GKf0XI",
  authDomain: "gr8ful-platform.firebaseapp.com",
  projectId: "gr8ful-platform",
  storageBucket: "gr8ful-platform.firebasestorage.app",
  messagingSenderId: "134075833851",
  appId: "1:134075833851:web:69c5db5c8c7312f2cb7f5e",
  measurementId: "G-Z3SC00KQCF",
};

// Singleton pattern — safe to call multiple times across packages
let app: FirebaseApp;
let db: Firestore;
let auth: Auth;
let fns: Functions;

export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]!;
  }
  return app;
}

export function getDb(): Firestore {
  if (!db) {
    db = getFirestore(getFirebaseApp());
    if (import.meta.env.DEV && !import.meta.env.VITE_FIREBASE_EMULATOR_DISABLED) {
      connectFirestoreEmulator(db, "127.0.0.1", 8080);
    }
  }
  return db;
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    auth = getAuth(getFirebaseApp());
    if (import.meta.env.DEV && !import.meta.env.VITE_FIREBASE_EMULATOR_DISABLED) {
      connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    }
  }
  return auth;
}

export function getFirebaseFunctions(): Functions {
  if (!fns) {
    const isDev = import.meta.env.DEV && !import.meta.env.VITE_FIREBASE_EMULATOR_DISABLED;
    const customDomain = import.meta.env.VITE_FUNCTIONS_CUSTOM_DOMAIN as string | undefined;
    fns = !isDev && customDomain
      ? getFunctions(getFirebaseApp(), customDomain)
      : getFunctions(getFirebaseApp());
    if (isDev) {
      connectFunctionsEmulator(fns, "127.0.0.1", 5001);
    }
  }
  return fns;
}
